import React from 'react';
import { Offcanvas, Button, Form, Card, Row, Col, Image, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FormSelect } from 'components/elements/form-select/FormSelect';
import { useTranslation } from 'react-i18next';

function OffcanvasUpdateGuideCategory({ show, onHide, selectedRow, onSubmit, isLoadingButton }) {
    const { t } = useTranslation();

    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title><h2>{t('Edit Guide Category')}</h2></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {/* Form */}
                <Form onSubmit={onSubmit}>
                    <Card className="mb-4">
                        <Card.Header className="card-header-height d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">{t('Guide Category')}</h4>
                        </Card.Header>
                        <Card.Body className="">
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* Title */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="title_category">{t('Title')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="title_category"
                                            placeholder={t('Enter Title')}
                                            defaultValue={selectedRow ? selectedRow.guide_category_title : ''}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* Guide Category Title Slug */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="title_slug_category">{t('Title Slug')}</Form.Label>
                                        <Link
                                            onClick={(e) => {
                                                e.preventDefault();
                                                const titleCategoryValue = document.getElementById('title_category').value;
                                                const formattedSlugCategory = titleCategoryValue.toLowerCase().replace(/\s+/g, '-');
                                                document.getElementById('title_slug_category').value = formattedSlugCategory;
                                            }}
                                            className="ms-2"
                                        >
                                            {t('generate')} <i className="fe fe-refresh-cw"></i>
                                        </Link>
                                        <Form.Control
                                            type="text"
                                            id="title_slug_category"
                                            placeholder={t('Enter Title Slug')}
                                            defaultValue={selectedRow ? selectedRow.guide_category_slug : ''}
                                            onFocus={(e) => {
                                                const titleCategoryValue = document.getElementById('title_category').value;
                                                if (e.target.value === '') {
                                                    e.target.value = titleCategoryValue.toLowerCase().replace(/\s+/g, '-');
                                                } 
                                            }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* Description */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="description_category">{t('Description')}</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={12}
                                            id="description_category"
                                            placeholder={t('Enter Description')}
                                            defaultValue={selectedRow ? selectedRow.guide_category_description : ''}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end mt-4">
                        <Button variant="secondary" onClick={onHide}>
                            {t('Cancel')}
                        </Button>
                        <Button className="ms-2 d-end" variant="primary" type="submit" disabled={isLoadingButton}>
                            {isLoadingButton ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    {t('Edit new Guide Category')}
                                </>
                            ) : (
                                t('Edit new Guide Category')
                            )}
                        </Button>
                    </div>
                </Form>
            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default OffcanvasUpdateGuideCategory;